module.exports = __webpack_public_path__ + "img/231.97d8aeea.png";